import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";

@Injectable({
  providedIn: "root",
})
export class SnackBarService {
  constructor(private snackBar: MatSnackBar) {}

  error(message: string, action: string = "") {
    this.snackBar.open(message, action, {
      verticalPosition: "top",
      horizontalPosition: "right",
      panelClass: "snackbar-error",
      duration: 3000,
    });
  }
}
